import React, { ComponentType, ReactElement } from "react";
import styles from "./GenericNavItem.module.css";
import { PanelId, usePanelContext } from "../../context/PanelContext";
import { Typography } from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";

interface GenericNavItem {
	iconPath?: string;
	panelId: PanelId;
	text?: string;
	width?: string;
	transformViewBox?: string;
	Icon?: ComponentType<SvgIconProps>;
}

const GenericNavItem: React.FunctionComponent<GenericNavItem> = ({
	iconPath,
	Icon,
	panelId,
	width = "60px",
	text,
	transformViewBox = "0 0 16 16",
}) => {
	const { expandedPanel, setExpandedPanel } = usePanelContext();
	const onItemClick = () => {
		expandedPanel === panelId
			? setExpandedPanel(null)
			: setExpandedPanel(panelId);
	};
	const iconColor = expandedPanel === panelId ? "white" : "black";

	return (
		<div
			id={panelId}
			style={{ width: width, padding: text ? "15px" : "22px" }}
			className={
				expandedPanel === panelId
					? styles.iconContainerSelected
					: styles.iconContainer
			}
			onClick={onItemClick}
		>
			{iconPath && (
				<svg
					className={styles.icon}
					width="16"
					height="16"
					viewBox={transformViewBox}
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d={iconPath} fill="#2A2E33" fillRule="evenodd" />
				</svg>
			)}

			{Icon && <Icon sx={{ color: iconColor }} />}

			{text && (
				<Typography
					className={styles.iconText}
					style={{ paddingBottom: "3px" }}
				>
					{text}
				</Typography>
			)}
		</div>
	);
};

export default GenericNavItem;
